import React from 'react';

function ServicesNationBuildingSection() {
  const styles = {
    section: {
      width: '100%',
      maxWidth: 1920,
      margin: '0 auto',
      padding: '80px clamp(24px, 12.5vw, 240px)',
      boxSizing: 'border-box',
      background: '#FFFFFF'
    },
    inner: {
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: 64,
      flexWrap: 'wrap'
    },
    leftCol: {
      flex: '1 1 440px',
      maxWidth: 640,
      minWidth: 280
    },
    rightCol: {
      flex: '1 1 380px',
      maxWidth: 636,
      minWidth: 300,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    },
    overlineRow: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      marginBottom: 16
    },
    overline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 14,
      lineHeight: '100%',
      letterSpacing: '-0.01em',
      textTransform: 'uppercase',
      color: '#090909',
      margin: 0
    },
    overlineRule: {
      width: 80,
      height: 2,
      background: '#E73123',
      flexShrink: 0
    },
    titleRow: {
      marginBottom: 24
    },
    titleRed: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#E73123',
      margin: 0
    },
    titleBlack: {
      fontFamily: 'Lato',
      fontWeight: 800,
      fontStyle: 'normal',
      fontSize: 32,
      lineHeight: 1.2,
      letterSpacing: 0,
      textTransform: 'uppercase',
      color: '#090909',
      margin: '4px 0 0 0'
    },
    body: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      color: '#838383',
      margin: '0 0 24px 0'
    },
    expertiseHeading: {
      fontFamily: 'Lato',
      fontWeight: 700,
      fontStyle: 'normal',
      fontSize: 20,
      lineHeight: 1.4,
      letterSpacing: 0,
      color: '#E73123',
      margin: '0 0 16px 0'
    },
    expertiseGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px 32px',
      marginBottom: 24
    },
    expertiseItem: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: 1.7,
      letterSpacing: 0,
      textTransform: 'capitalize',
      color: '#090909',
      margin: 0,
      paddingLeft: 20,
      position: 'relative'
    },
    bullet: {
      position: 'absolute',
      left: 0,
      top: 14,
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: '#E73123'
    },
    imageWrap: {
      position: 'relative',
      flex: 1,
      minHeight: 400,
      overflow: 'hidden',
      opacity: 1
    },
    sectionImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'top center',
      display: 'block'
    },
    ctaBtn: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      display: 'inline-block',
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: 14,
      padding: '14px 28px',
      background: '#E73123',
      color: '#FFFFFF',
      textDecoration: 'none',
      textTransform: 'uppercase',
      textAlign: 'center'
    }
  };

  const expertiseItems = [
    'Bridges and flyovers',
    'Highways and expressways',
    'High-speed rail infrastructure',
    'Large public utility structures',
    'Metro rail and railway projects'
  ];

  return React.createElement('section', { style: styles.section, className: 'section-padding' },
    React.createElement('div', { style: styles.inner, className: 'section-inner-wrap' },
      React.createElement('div', { style: styles.leftCol, className: 'section-text-col' },
        React.createElement('div', { style: styles.overlineRow },
          React.createElement('p', { style: styles.overline }, 'NATION-BUILDING WORKS'),
          React.createElement('div', { style: styles.overlineRule })
        ),
        React.createElement('div', { style: styles.titleRow },
          React.createElement('h2', { style: styles.titleRed }, 'HEAVY CIVIL'),
          React.createElement('h2', { style: styles.titleBlack }, 'INFRASTRUCTURE')
        ),
        React.createElement('p', { style: styles.body },
          'We play a key role in building large-scale public infrastructure that supports economic growth and urban development.'
        ),
        React.createElement('h3', { style: styles.expertiseHeading }, 'Our Expertise Covers:'),
        React.createElement('div', { style: styles.expertiseGrid },
          expertiseItems.map(function (item, i) {
            return React.createElement('p', { key: i, style: styles.expertiseItem },
              React.createElement('span', { style: styles.bullet }),
              item
            );
          })
        ),
        React.createElement('p', { style: styles.body },
          'With disciplined planning and advanced execution techniques, we deliver strong and reliable foundations for complex civil engineering projects. Our work contributes to critical transportation networks and national infrastructure initiatives.'
        )
      ),
      React.createElement('div', { style: styles.rightCol, className: 'section-image-col' },
        React.createElement('div', { style: styles.imageWrap, className: 'section-image-wrap' },
          React.createElement('img', {
            src: '/nationbuilding.jpg',
            alt: 'Highway and civil infrastructure construction',
            style: styles.sectionImage
          }),
          React.createElement('a', { href: '#contact', style: styles.ctaBtn }, 'REQUEST A CONSULTATION')
        )
      )
    )
  );
}

export default ServicesNationBuildingSection;
